import styled from 'styled-components'

const PageHeader = styled.div`
  text-align: left;
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  padding: 20px 0;
`
export default PageHeader
